import { useTranslation } from "react-i18next";

import { getLangParams } from "../../../utils/helpers";

import { IconSprite } from "../../ui/IconSprite/IconSprite";
import { addStyles } from "./addStyles";
import { DateInfo } from "./components/DateInfo";

import { Divider } from "../../ui/Divider/Divider.styled";
import {
  CardStyled,
  LinkStyled,
  NavigateWrapper,
  Text,
  Title,
} from "./BlogCard.styled";

export const BlogCard = ({ title, description, date, index, slug }) => {
  const { t } = useTranslation();
  const lang = getLangParams();
  const cardsCount = 6;

  const backgroundColors = ["#0C0C0E", "#D4FE75", "#FFFFFF"];
  const iconCircleColors = ["#82818E", "#F2FFD7", "#F7F7F8"];
  const textColors = ["#FFFFFF", "#0C0C0E", "#0C0C0E"];
  const secondaryTextColors = ["#A9A9A9", "#54535D", "#54535D"];
  const buttonBackgroundColors = ["#82818E", "#F2FFD7", "#F7F7F8"];
  const dividerColors = ["#54535D", "#c5c5c5", "#c5c5c5"];
  const labelColors = ["#A9A9A9", "#0C0C0E", "#0C0C0E"];
  const buttonColors = ["#54535D", "#f2ffd7", "#f7f7f8"];
  const hover = ["rgba(255, 255, 255, 0.56)", "#9EEB00", "#E6E6E6"];
  const active = ["rgba(255, 255, 255, 0.72)", "#7CB800", "#CCC"];

  const colorOptions = {
    background: [...backgroundColors, ...[...backgroundColors].reverse()],
    iconCircle: [...iconCircleColors, ...[...iconCircleColors].reverse()],
    text: [...textColors, ...[...textColors].reverse()],
    secondaryText: [
      ...secondaryTextColors,
      ...[...secondaryTextColors].reverse(),
    ],
    buttonBackground: [
      ...buttonBackgroundColors,
      ...[...buttonBackgroundColors].reverse(),
    ],
    dividerColor: [...dividerColors, ...[...dividerColors.reverse()]],
    labels: [...labelColors, ...[...labelColors].reverse()],
    buttonColor: [...buttonColors, ...[...buttonColors].reverse()],
    buttonHover: [...hover, ...[...hover].reverse()],
    buttonActive: [...active, ...[...active].reverse()],
  };

  const cardBackground = colorOptions.background[index % cardsCount] || "";
  const titleColor = colorOptions.text[index % cardsCount] || "";
  const descriptionColor = colorOptions.secondaryText[index % cardsCount] || "";
  const buttonColor = colorOptions.buttonColor[index % cardsCount] || "";
  const buttonText = colorOptions.text[index % cardsCount] || "";
  const labelColor = colorOptions.labels[index % cardsCount] || "";
  const dividerColor = colorOptions.dividerColor[index % cardsCount] || "";
  const buttonHover = colorOptions.buttonHover[index % cardsCount] || "";
  const buttonActive = colorOptions.buttonActive[index % cardsCount] || "";

  return (
    <CardStyled cardBackground={cardBackground}>
      <Title titleColor={titleColor}>{title}</Title>

      <Text descriptionColor={descriptionColor}>{description}</Text>

      <NavigateWrapper>
        <Divider addStyles={addStyles.divider(dividerColor)} />

        <DateInfo
          date={date}
          colors={{ dividerColor, labelColor, buttonText }}
        />

        <LinkStyled
          to={`/${lang}blog/${slug}/`}
          buttoncolor={buttonColor}
          buttontext={buttonText}
          buttonhover={buttonHover}
          buttonactive={buttonActive}
        >
          <IconSprite tag="eys" width="20" height="21" />
          {t("global.view")}
        </LinkStyled>
      </NavigateWrapper>
    </CardStyled>
  );
};
